export default [
	{
		modulo: 26,
		privilegio: 170,
		routerName: 'contratos-abastecimento',
		routerPath: '/contratos-abastecimento',
		componentName: 'CadastroContratosAbastecimento',
		componentPath: 'modules/layout/gestao-contratos/abastecimento/main'
	},
	{
		modulo: 18,
		privilegio: 249,
		routerName: 'contratos-sbh',
		routerPath: '/contratos-sbh',
		componentName: 'CadastroContratoSBH',
		componentPath: 'modules/layout/gestao-contratos/sbh/main'
	},
	{
		modulo: 18,
		privilegio: 240,
		routerName: 'status-contrato',
		routerPath: '/status-contrato',
		componentName: 'StatusContrato',
		componentPath: 'modules/layout/gestao-contratos/status-contrato/main'
	},
	{
		modulo: 18,
		privilegio: 240,
		routerName: 'status-contrato-cadastro',
		routerPath: '/status-contrato/cadastro',
		componentName: 'StatusContratoCadastro',
		componentPath: 'modules/layout/gestao-contratos/status-contrato/cadastro'
	},
	{
		modulo: 18,
		privilegio: 240,
		props: true,
		routerName: 'status-contrato-editar',
		routerPath: '/status-contrato/editar/:id',
		componentName: 'StatusContratoEditar',
		componentPath: 'modules/layout/gestao-contratos/status-contrato/cadastro'
	},
	{
		modulo: 18,
		privilegio: 241,
		routerName: 'tipo-contrato',
		routerPath: '/tipo-contrato',
		componentName: 'TipoContrato',
		componentPath: 'modules/layout/gestao-contratos/tipo-contrato/main'
	},
	{
		modulo: 18,
		privilegio: 241,
		routerName: 'tipo-contrato-cadastro',
		routerPath: '/tipo-contrato/cadastro',
		componentName: 'TipoContratoCadastro',
		componentPath: 'modules/layout/gestao-contratos/tipo-contrato/cadastro'
	},
	{
		modulo: 18,
		privilegio: 241,
		props: true,
		routerName: 'tipo-contrato-editar',
		routerPath: '/tipo-contrato/editar/:id',
		componentName: 'TipoContratoEditar',
		componentPath: 'modules/layout/gestao-contratos/tipo-contrato/cadastro'
	},
	{
		modulo: 18,
		privilegio: 250,
		routerName: 'contratos-genericos',
		routerPath: '/contratos-genericos',
		componentName: 'ContratosGenericos',
		componentPath: 'modules/layout/gestao-contratos/contratos-genericos/main'
	},
	{
		modulo: 18,
		privilegio: 250,
		routerName: 'funcao-contratual',
		routerPath: '/funcao-contratual',
		componentName: 'FuncaoContratual',
		componentPath: 'modules/layout/gestao-contratos/funcao-contratual/main'
	}
]
